"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var logs_1 = require("@ledgerhq/logs");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var promise_1 = require("../../promise");
var logic_1 = require("./logic");
var getValidatorStatus = function (cosmosAccount, address) { return __awaiter(void 0, void 0, void 0, function () {
    var status, validatorInfo, rawStatus, stargateStatusMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                status = ["unbonded", "unbonding", "bonded"];
                return [4 /*yield*/, cosmosAccount.getValidatorInfo(address)];
            case 1:
                validatorInfo = _a.sent();
                return [4 /*yield*/, validatorInfo.getActiveStatus()];
            case 2:
                rawStatus = _a.sent();
                // Pre stargate
                if (["0", "1", "2"].includes(rawStatus)) {
                    return [2 /*return*/, status[parseInt(rawStatus)]];
                }
                stargateStatusMap = {
                    BOND_STATUS_UNBONDED: "unbonded",
                    BOND_STATUS_UNBONDING: "unbonding",
                    BOND_STATUS_BONDED: "bonded"
                };
                return [2 /*return*/, stargateStatusMap[rawStatus] || "unbonded"];
        }
    });
}); };
var getFlattenDelegation = function (cosmosAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var delegations, pendingRewards;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cosmosAccount.getDelegations()];
            case 1:
                delegations = _a.sent();
                return [4 /*yield*/, cosmosAccount.getPendingRewards()];
            case 2:
                pendingRewards = _a.sent();
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(10, delegations, function (delegation) { return __awaiter(void 0, void 0, void 0, function () {
                        var validatorAddress, reward, i, _a, _b;
                        var _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0: return [4 /*yield*/, delegation.getValidatorAddress()];
                                case 1:
                                    validatorAddress = _d.sent();
                                    i = 0;
                                    _d.label = 2;
                                case 2:
                                    if (!(i < pendingRewards.length)) return [3 /*break*/, 6];
                                    return [4 /*yield*/, pendingRewards[i].getValidatorAddress()];
                                case 3:
                                    if (!((_d.sent()) === validatorAddress)) return [3 /*break*/, 5];
                                    return [4 /*yield*/, pendingRewards[i].getRewardAmount()];
                                case 4:
                                    reward = _d.sent();
                                    return [3 /*break*/, 6];
                                case 5:
                                    i++;
                                    return [3 /*break*/, 2];
                                case 6:
                                    _c = {};
                                    _a = buildBigNumber_1.libcoreAmountToBigNumber;
                                    return [4 /*yield*/, delegation.getDelegatedAmount()];
                                case 7: return [4 /*yield*/, _a.apply(void 0, [_d.sent()])];
                                case 8:
                                    _c.amount = _d.sent(),
                                        _c.validatorAddress = validatorAddress;
                                    if (!reward) return [3 /*break*/, 10];
                                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(reward)];
                                case 9:
                                    _b = _d.sent();
                                    return [3 /*break*/, 11];
                                case 10:
                                    _b = new bignumber_js_1.BigNumber(0);
                                    _d.label = 11;
                                case 11:
                                    _c.pendingRewards = _b;
                                    return [4 /*yield*/, getValidatorStatus(cosmosAccount, validatorAddress)];
                                case 12: return [2 /*return*/, (_c.status = _d.sent(),
                                        _c)];
                            }
                        });
                    }); })];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getFlattenRedelegations = function (cosmosAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var redelegations, toFlatten;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cosmosAccount.getRedelegations()];
            case 1:
                redelegations = _a.sent();
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, redelegations, function (redelegation) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = promise_1.promiseAllBatched;
                                    _b = [3];
                                    return [4 /*yield*/, redelegation.getEntries()];
                                case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent(), function (entry) { return __awaiter(void 0, void 0, void 0, function () {
                                            var _a;
                                            var _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        _b = {};
                                                        return [4 /*yield*/, redelegation.getSrcValidatorAddress()];
                                                    case 1:
                                                        _b.validatorSrcAddress = _c.sent();
                                                        return [4 /*yield*/, redelegation.getDstValidatorAddress()];
                                                    case 2:
                                                        _b.validatorDstAddress = _c.sent();
                                                        _a = buildBigNumber_1.libcoreBigIntToBigNumber;
                                                        return [4 /*yield*/, entry.getInitialBalance()];
                                                    case 3: return [4 /*yield*/, _a.apply(void 0, [_c.sent()])];
                                                    case 4:
                                                        _b.amount = _c.sent();
                                                        return [4 /*yield*/, entry.getCompletionTime()];
                                                    case 5: return [2 /*return*/, (_b.completionDate = _c.sent(),
                                                            _b)];
                                                }
                                            });
                                        }); }]))];
                                case 2: return [2 /*return*/, _c.sent()];
                            }
                        });
                    }); })];
            case 2:
                toFlatten = _a.sent();
                return [2 /*return*/, toFlatten.reduce(function (old, current) { return __spreadArray(__spreadArray([], __read(old), false), __read(current), false); }, [])];
        }
    });
}); };
var getFlattenUnbonding = function (cosmosAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var unbondings, toFlatten;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cosmosAccount.getUnbondings()];
            case 1:
                unbondings = _a.sent();
                return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, unbondings, function (unbonding) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = promise_1.promiseAllBatched;
                                    _b = [3];
                                    return [4 /*yield*/, unbonding.getEntries()];
                                case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent(), function (entry) { return __awaiter(void 0, void 0, void 0, function () {
                                            var _a;
                                            var _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        _b = {};
                                                        return [4 /*yield*/, unbonding.getValidatorAddress()];
                                                    case 1:
                                                        _b.validatorAddress = _c.sent();
                                                        _a = buildBigNumber_1.libcoreBigIntToBigNumber;
                                                        return [4 /*yield*/, entry.getInitialBalance()];
                                                    case 2: return [4 /*yield*/, _a.apply(void 0, [_c.sent()])];
                                                    case 3:
                                                        _b.amount = _c.sent();
                                                        return [4 /*yield*/, entry.getCompletionTime()];
                                                    case 4: return [2 /*return*/, (_b.completionDate = _c.sent(),
                                                            _b)];
                                                }
                                            });
                                        }); }]))];
                                case 2: return [2 /*return*/, _c.sent()];
                            }
                        });
                    }); })];
            case 2:
                toFlatten = _a.sent();
                return [2 /*return*/, toFlatten.reduce(function (old, current) { return __spreadArray(__spreadArray([], __read(old), false), __read(current), false); }, [])];
        }
    });
}); };
var filterDelegation = function (delegations) {
    return delegations.filter(function (delegation) { return delegation.amount.gt(0); });
};
var getCosmosResources = function (account, coreAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var cosmosAccount, flattenDelegation, flattenUnbonding, flattenRedelegation, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, coreAccount.asCosmosLikeAccount()];
            case 1:
                cosmosAccount = _a.sent();
                return [4 /*yield*/, getFlattenDelegation(cosmosAccount)];
            case 2:
                flattenDelegation = _a.sent();
                return [4 /*yield*/, getFlattenUnbonding(cosmosAccount)];
            case 3:
                flattenUnbonding = _a.sent();
                return [4 /*yield*/, getFlattenRedelegations(cosmosAccount)];
            case 4:
                flattenRedelegation = _a.sent();
                res = {
                    delegations: filterDelegation(flattenDelegation),
                    redelegations: flattenRedelegation,
                    unbondings: flattenUnbonding,
                    delegatedBalance: flattenDelegation.reduce(function (old, current) { return old.plus(current.amount); }, new bignumber_js_1.BigNumber(0)),
                    pendingRewardsBalance: flattenDelegation.reduce(function (old, current) { return old.plus(current.pendingRewards); }, new bignumber_js_1.BigNumber(0)),
                    unbondingBalance: flattenUnbonding.reduce(function (old, current) { return old.plus(current.amount); }, new bignumber_js_1.BigNumber(0)),
                    withdrawAddress: ""
                };
                return [2 /*return*/, res];
        }
    });
}); };
var postBuildAccount = function (_a) {
    var account = _a.account, coreAccount = _a.coreAccount;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, cosmosAccount, seq;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    (0, logs_1.log)("cosmos/post-buildAccount", "getCosmosResources");
                    _b = account;
                    return [4 /*yield*/, getCosmosResources(account, coreAccount)];
                case 1:
                    _b.cosmosResources = _c.sent();
                    (0, logs_1.log)("cosmos/post-buildAccount", "getCosmosResources DONE");
                    account.spendableBalance = (0, logic_1.getMaxEstimatedBalance)(account, new bignumber_js_1.BigNumber(0));
                    if (account.spendableBalance.lt(0)) {
                        account.spendableBalance = new bignumber_js_1.BigNumber(0);
                    }
                    if (!!account.used) return [3 /*break*/, 4];
                    return [4 /*yield*/, coreAccount.asCosmosLikeAccount()];
                case 2:
                    cosmosAccount = _c.sent();
                    return [4 /*yield*/, cosmosAccount.getSequence()];
                case 3:
                    seq = _c.sent();
                    account.used = seq != "";
                    _c.label = 4;
                case 4: return [2 /*return*/, account];
            }
        });
    });
};
exports["default"] = postBuildAccount;
//# sourceMappingURL=libcore-postBuildAccount.js.map